<template>
  <v-card class="homework-upload">
    <v-subheader>
      <v-icon medium color="success" class="mr-2">assignment_returned</v-icon>
      {{date}}
      <span class="ml-2">Загружена домашняя работа уровня {{level}}</span>
    </v-subheader>
    <v-layout row>
      <v-flex>
        <v-card tile flat class="grey lighten-4">
          <v-card-text>
            <span class="font-weight-medium">Инфо: </span>
            скачать по <a :href="link"><span class="font-weight-medium">ссылке</span></a>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-card>
</template>

<script>
  export default {
    name: "HomeworkUpload",
    props: ["date", "description", "level", "link"]
  }
</script>

<style scoped>
  .homework-upload {
    border: 1px solid #78909C;
  }

</style>